import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { useEnrollmentFormData } from './StudentEnrollmentFormContext';

const Container = styled.div`
  max-width: 700px;
  margin: 40px auto;
  padding: 120px;
  background: #fff;
  border-radius: 15px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 32px;
`;

const SubTitle = styled.div`
  text-align: center;
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 18px;
`;

const SchoolHeader = styled.div`
  text-align: center;
  margin-bottom: 18px;
`;

const SchoolLogo = styled.img`
  max-width: 350px;
  margin-bottom: 8px;
`;

const SchoolInfo = styled.div`
  font-size: 0.95rem;
  color: #222;
`;

const FormSection = styled.div`
  margin-bottom: 32px;
`;

const FormRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
`;

const Label = styled.label`
  min-width: 120px;
  font-weight: 500;
  color: #222;
`;

const BlankLine = styled.span`
  display: inline-block;
  min-width: 350px;
  border-bottom: 1px solid #333;
  margin-left: 8px;
  padding: 0 4px;
  font-weight: 500;
`;

const DownloadButton = styled.button`
  background: #334293;
  color: white;
  padding: 12px 32px;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 32px auto 0 auto;
  display: block;

  &:hover {
    background: #2c3e50;
    transform: translateY(-2px);
  }
`;

const LoadingMessage = styled.div`
  text-align: center;
  color: #6c757d;
  font-size: 1.1rem;
  margin: 40px 0;
`;

const ErrorMessage = styled.div`
  background: #f8d7da;
  color: #721c24;
  padding: 16px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  border: 1px solid #f5c6cb;
`;

const PrintHideStyle = createGlobalStyle`
  @media print {
    .print-hide {
      display: none !important;
    }
    
    @page {
      margin: 0;
      size: A4;
    }
    
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`;

const StudentEmergencyContactForm = () => {
  const { email } = useParams();
  const { data: student, loading, error } = useEnrollmentFormData();
  const docRef = useRef();

  const handleDownload = () => {
    window.print();
  };

  if (loading) {
    return <Container><LoadingMessage>Loading student information...</LoadingMessage></Container>;
  }
  if (error || !student) {
    return <Container><ErrorMessage>{error || 'Student not found'}</ErrorMessage></Container>;
  }

console.log(student)
  // Emergency contact fields (adjust field names as per your DB)
  const contacts = [
    {
      name: student.em_full_name || 'N/A',
      number: student.em_phone_home || 'N/A',
      relationship: student.em_relationship || 'N/A',
    },
    {
      name: 'N/A',
      number: 'N/A',
      relationship: 'N/A',
    },
    {
      name: 'N/A',
      number: 'N/A',
      relationship: 'N/A',
    },
  ];

  return (
    <Container>
      <div ref={docRef} style={{ background: '#fff', color: '#222', padding: 0 }}>
        <SchoolHeader>
          <SchoolLogo src={process.env.PUBLIC_URL + '/forms_logo.png'} alt="Chicago Community Learning Center Logo" />
          <SchoolInfo>
            Chicago Campus: 840 W. Irving Park Road, suite 203, Illinois 60613 Office: (773) 506-1503<br />
            Evergreen Campus: 9730 S. Western Ave, suite 502, Evergreen Park Illinois 60805<br />
            www.cclctraining.org
          </SchoolInfo>
        </SchoolHeader>
        <Title>EMERGENCY CONTACT FORM</Title>
        {contacts.map((contact, idx) => (
          <FormSection key={idx}>
            <FormRow>
              <Label>Name:</Label>
              <BlankLine>{contact.name}</BlankLine>
            </FormRow>
            <FormRow>
              <Label>Number:</Label>
              <BlankLine>{contact.number}</BlankLine>
            </FormRow>
            <FormRow>
              <Label>Relationship:</Label>
              <BlankLine>{contact.relationship}</BlankLine>
            </FormRow>
          </FormSection>
        ))}
      </div>
      <PrintHideStyle />
      <DownloadButton className="print-hide" onClick={handleDownload}>Print Form</DownloadButton>
    </Container>
  );
};

export default StudentEmergencyContactForm;